<template>
  <div :class="`tags ${inline ? 'd-inline-block' : ''} ${formControl ? 'form-control' : ''}`">
    <b-badge v-for="(tag, index) in tags" :key="`tag${index}`" variant="tag" class="mr-1" @click.prevent.stop="onClick">
      {{ tag.name }}
    </b-badge>
    <b-button
      v-if="!hideEdit && !formControl"
      variant="link"
      size="sm"
      class="text-muted p-0"
      @click="onClick"
      :title="trans('modify')"
      :disabled="disabled"
    >
      <span v-if="(!tags || tags.length == 0) && !!placeholder && !hideButtonLabel">
        {{ placeholder }}
      </span>
      <small><i class="fa fa-fw fa-edit"></i></small>
    </b-button>
    <tags-modal
      v-if="!hideEdit"
      :id="tagsModalId"
      :organization="organization"
      :all-tags="all_tags"
      :model="localModel"
      :attribute="attribute"
      :type="type"
      :label="label"
      :placeholder="placeholder"
      @saved="onChangeModelTags"
      @all-tags="onChangeAllTags"
    ></tags-modal>
  </div>
</template>

<script>
  import TagsModal from './TagsModal'

  export default {
    props: {
      organization: Object,
      model: Object,
      attribute: {
        type: String,
        default: 'tags',
      },
      type: String,
      allTags: Array,
      placeholder: { // also button label
        type: String,
        default: trans('tags'),
      },
      label: {
        type: String,
        default: 'tag',
      },
      hideButtonLabel: {
        type: Boolean,
        default: false,
      },
      hideEdit: {
        type: Boolean,
        default: false,
      },
      inline: {
        type: Boolean,
        default: false,
      },
      formControl: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      TagsModal,
    },
    data() {
      return {
        trans: trans,
        tags: this.model[this.attribute],
        all_tags: this.allTags,
      }
    },
    computed: {
      localModel() {
        return {
          id: this.model.id,
          name: this.model.name,
          tags: this.tags,
        }
      },
      tagsModalId() {
        return `tags-modal-${this.localModel.id}-${this._uid}`
      },
    },
    watch: {
      model() {
        this.tags = this.model[this.attribute]
      },
      allTags() {
        this.all_tags = this.allTags
      },
    },
    methods: {
      onClick() {
        if (this.disabled || !!this.formControl || this.hideEdit) return
        this.$bvModal.show(this.tagsModalId)
      },
      onChangeModelTags(tags) {
        this.tags = tags
        this.$emit('saved', this.tags)
      },
      onChangeAllTags(tags) {
        this.all_tags = tags
        this.$emit('all-tags', this.all_tags)
      },
    },
  }
</script>